import { AuthenticationHttpClient_default, AuthenticationService_default, authenticateHttpRequestInterceptor, init_AuthenticationHttpClient, init_AuthenticationService, init_authenticateHttpRequestInterceptor } from "./chunk-ON7PLO5R.js";
import "./chunk-PNKVD2UK.js";

// src/hooks/useAuthentication.ts
init_AuthenticationService();
import { useEffect, useState } from "react";
function useAuthentication() {
  const [token, setToken] = useState(void 0);
  useEffect(() => {
    const unsubscribe = AuthenticationService_default.onTokenChange(t => {
      setToken(t);
    });
    return () => {
      unsubscribe();
    };
  }, []);
  return AuthenticationService_default;
}

// src/index.ts
init_authenticateHttpRequestInterceptor();
init_AuthenticationHttpClient();
init_AuthenticationService();

// src/react-query/invalidateQueriesOnTokenChange.ts
init_AuthenticationService();
function invalidateQueriesOnTokenChange(queryClient) {
  AuthenticationService_default.onTokenChange(() => {
    queryClient.invalidateQueries();
  });
}
export { authenticateHttpRequestInterceptor, AuthenticationHttpClient_default as authenticationHttpClient, AuthenticationService_default as authenticationService, invalidateQueriesOnTokenChange, useAuthentication };